import { XMarkIcon, CheckBadgeIcon } from "@heroicons/react/20/solid";
import { format } from "date-fns";
import pDebounce from "p-debounce";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { Actions as ADMINACTIONS } from "../../../store/actions/adminActions";
import DatePicker from "react-datepicker";
import { DateInputFormat } from "@/components/common/DateComponents";
import { merge, setWith } from "lodash";
import Select from "react-select";
import { useEffect } from "react";
import Tooltip from "@/components/common/tooltip/Tooltip";

const GlobalUserNotificationModal = ({
	closeModal,
	modalStatus,
	typeOptions,
	saveNotification,
	notification,
	id,
}) => {
	const [data, setData] = useState({});
	const updateField = (field, value) => {
		if (!field) return;
		if (field.includes("[")) field = setWith({}, field, value, Object);
		const newData = merge(data, { ...(typeof field == "object" ? field : { [field]: value }) });

		setData({ ...newData });
	};

	useEffect(() => {
		if (notification?.id) {
			setData(notification);
		} else {
			setData({});
		}
	}, [modalStatus]);


	const onSubmit = (e) => {
		e.preventDefault();
		saveNotification(data);
	};

	if (!modalStatus) {
		return null;
	}

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "75%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={() => {
											setData({});
											closeModal()}}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">
							{notification ? `Editing notification "${notification?.title}"` : `Create Global User Notification`}
							</h3>
						</div>
						<form onSubmit={onSubmit}>
							<div
								className="col-sm-12"
								style={{ padding: "4rem", paddingTop: 10, paddingBottom: 0 }}
							>
								<div>
									<div div className="col-sm-12 form-material pl-0">
										<div className="col-sm-6 form-material pl-0">
											<label htmlFor="notificationTitle">Title</label>
											<input
												id="notificationTitle"
												className="form-input form-control"
												required
												autoComplete="off"
												value={data?.title || ""}
												onChange={(e) => {
													updateField("title", e.target.value);
												}}
											/>
										</div>
									</div>
									<div className="col-sm-12 form-material pl-0">
										<div className="col-sm-6 form-material pl-0">
											<label htmlFor="date">Date</label>
											<DatePicker
												autoComplete="off"
												name="effectiveDate"
												dateFormat="do MMM yyyy"
												customInput={<DateInputFormat />}
												wrapperClassName="full-width"
												selected={data?.effectiveDate ? new Date(data?.effectiveDate) : null}
												onChange={(e) => {
													updateField("effectiveDate", e ? format(e, "yyyy-MM-dd") : null);
												}}/>
										</div>
										<div className="col-sm-6 form-material pl-0 pr-0">
											<label htmlFor="type">Type</label>
											<Select
												name="type"
												options={typeOptions}
												value={typeOptions?.find((option) => option.value == data?.type)}
												wrapperClassName="full-width"
												required
												onChange={(e) => {
													updateField("type", e.value);
												}}/>
										</div>
									</div>
									<div className="col-sm-12 form-material pl-0">
										<label htmlFor="notificationDescription">Description</label>
										<input
											id="notificationDescription"
											className="form-input form-control"
											required
											autoComplete="off"
											value={data?.description || ""}
											onChange={(e) => {
												updateField("description", e.target.value);
											}}
										/>
									</div>
									<div className="col-sm-12 pl-0">
										<label htmlFor="notificationContent">Content</label>
											<textarea
												id="notificationContent"
												className="form-input form-control"
												required
												autoComplete="off"
												rows="5"
												value={data?.alertContent || ""}
												onChange={(e) => {
													updateField("alertContent", e.target.value);
												}}
											/>
									</div>
									<div className="col-sm-12 pl-0">
										<div>
											<h4 style={{paddingTop: "6px", paddingBottom: "6px", width: "fit-content"}}>
												<Tooltip content={"This is the message that will be displayed to the user."}>Call to Action</Tooltip>
											</h4>
										</div>
										<div className="col-sm-6 form-material pl-0">
												<label htmlFor="callToActionMessage">Message</label>
												<input
													id="callToActionMessage"
													className="form-input form-control"
													required
													autoComplete="off"
													value={data?.callToAction?.message || ""}
													onChange={(e) => {
														updateField("callToAction[message]", e.target.value);
													}}/>
										</div>
										<div className="col-sm-6 form-material pl-0 pr-0">
											<label htmlFor="callToActionLink">URL</label>
											<input
												id="callToActionLink"
												className="form-input form-control"
												required
												autoComplete="off"
												type="url"
												value={data?.callToAction?.url || ""}
												onChange={(e) => {
													updateField("callToAction[url]", e.target.value);
												}}/>
										</div>
									</div>
									<div className="col-sm-12 pl-0">
										<div className="col-sm-6 pl-0">
											<label className="css-input switch switch-sm switch-success">
												<input
													type="checkbox"
													className="checkbox-toggle"
													checked={!!data?.read}
													onChange={(e) => {
														updateField("read", e.target.checked);
													}}
												/>
												<span /> Notification is read
											</label>
										</div>
										<div className="col-sm-6 pl-0">
											<label className="css-input switch switch-sm switch-success">
												<input
													type="checkbox"
													className="checkbox-toggle"
													checked={!!data?.archived}
													onChange={(e) => {
														updateField("archived", e.target.checked);
													}}
												/>
												<span /> Notification is archived
												</label>
										</div>
									</div>
								</div>
								<div className="clearfix"></div>
							</div>
							<div className="clearfix"></div>

								<div
									className="flex-auto buttons"
									style={{ paddingBottom: 20, paddingRight: "4rem" }}
								>
									{
										<button
											className="btn btn-success pull-right"
											type="submit"
										>
											<CheckBadgeIcon
												className="w-7 h-7 mr-3"
												style={{ verticalAlign: "text-bottom" }}
											/>
											{notification ? "Update" : "Create"}
										</button>
									}
									<div className="clearfix"></div>
								</div>
						</form>
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const typeOptions = [{ value: "notification", label: "Notification" }, { value: "update", label: "Update" }];
	const notification = state?.admin?.notifications?.find((notification) => notification.id === state?.admin?.notificationId);
	return {
		modalStatus: state?.admin?.createNotificationModal,
		typeOptions,
		notification,
	};
};

const mapDispatchToProps = (dispatch) => ({
	savePaymentHandleStatus: (payload) => dispatch(ADMINACTIONS.savePaymentHandleStatus(payload)),
	closeModal: () => dispatch(ADMINACTIONS.getCreateNotificationModal(false, null)),
	saveNotification: (payload) => dispatch(ADMINACTIONS.saveNotification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalUserNotificationModal);
